module.exports = __webpack_public_path__ + "img/GS_Profile-Thobile Sibiya.60b4e0a0.png";